import { Routes } from '@angular/router';

export const OPEN_FEEDBACK_CREATE = 'openFeedbackCreate';

export const DESKTOP_FEEDBACK_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./components/feedback-placeholder/feedback-placeholder.component').then(
        c => c.DesktopFeedbackPlaceholderComponent,
      ),
  },
  {
    path: 'new',
    data: { [OPEN_FEEDBACK_CREATE]: true },
    loadComponent: () =>
      import('./components/feedback-placeholder/feedback-placeholder.component').then(
        c => c.DesktopFeedbackPlaceholderComponent,
      ),
  },
  {
    path: ':id',
    loadComponent: () =>
      import('./components/feedback-details/feedback-details.component').then(
        c => c.DesktopFeedbackDetailsComponent,
      ),
  },
  {
    path: ':id/add',
    redirectTo: ':id',
    pathMatch: 'full',
  },
];
